// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type DocumentCollectionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DocumentCollectionsQuery = { __typename?: 'Query', documentCollections: Array<{ __typename?: 'DocumentCollection', id: string, name: string, description?: string | null, icon: Types.DocumentCollectionIcon, createdAt: any, updatedAt: any, documentFieldsCount: number }> };


export const DocumentCollectionsDocument = gql`
    query DocumentCollections {
  documentCollections {
    id
    name
    description
    icon
    createdAt
    updatedAt
    documentFieldsCount
  }
}
    `;

/**
 * __useDocumentCollectionsQuery__
 *
 * To run a query within a React component, call `useDocumentCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDocumentCollectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>(DocumentCollectionsDocument, options);
      }
export function useDocumentCollectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>(DocumentCollectionsDocument, options);
        }
// @ts-ignore
export function useDocumentCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>;
export function useDocumentCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DocumentCollectionsQuery | undefined, DocumentCollectionsQueryVariables>;
export function useDocumentCollectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>(DocumentCollectionsDocument, options);
        }
export type DocumentCollectionsQueryHookResult = ReturnType<typeof useDocumentCollectionsQuery>;
export type DocumentCollectionsLazyQueryHookResult = ReturnType<typeof useDocumentCollectionsLazyQuery>;
export type DocumentCollectionsSuspenseQueryHookResult = ReturnType<typeof useDocumentCollectionsSuspenseQuery>;
export type DocumentCollectionsQueryResult = ApolloReactCommon.QueryResult<DocumentCollectionsQuery, DocumentCollectionsQueryVariables>;